import { memdbRequest, memdbRequestV3 } from "./index.js";
export function searchSchools({ schoolTypes, ...params }) {
    return memdbRequestV3.get("/schools", {
        params: {
            ...params,
            ...(schoolTypes && { schoolTypes: schoolTypes.join(",") }),
        },
    });
}
export function getSchoolDetails(id) {
    return memdbRequestV3.get(`/schools/${id}`);
}
export function getSchoolClassifications(ids) {
    return memdbRequestV3.get("/schools", {
        params: { ids: ids.join(",") },
    });
}
export function getDistrictSchools(districtId) {
    return memdbRequestV3.get("/schools", {
        params: { districtId },
    });
}
export function getSchool(id, schema, token = "") {
    return memdbRequest.get(`/school/${id}`, {
        params: { schema },
        ...(token && { headers: { token } }),
    });
}
export function getSchools(params, schema, token = "") {
    return memdbRequest.get("/school/name", {
        params: { ...params, schema },
        ...(token && { headers: { token } }),
    });
}
export function updateSchoolBreak({ id, ...data }) {
    return memdbRequest.post(`/school/${id}/break`, {
        body: data,
    });
}
//# sourceMappingURL=school.js.map